export function capitalizeFirstLetter(str) {
  if (str) return `${str?.[0]?.toUpperCase()}${str?.slice(1)?.toLowerCase()}`;

  return null;
}
